import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore, useCartStore } from '../../store';
import './Header.css';

const Header: React.FC = () => {
  const { isAuthenticated, user, logout } = useAuthStore();
  const { cart, fetchCart } = useCartStore();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      fetchCart();
    }
  }, [isAuthenticated, fetchCart]);

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/shop?search=${searchQuery}`);
    }
  };

  const cartItemsCount = cart?.items_count || 0;

  return (
    <header className="header">
      {/* Top Header (slim) */}
      <div className="header__top">
        <div className="container">
          <div className="header__top__left">
            <p style={{ fontSize: '11px', margin: 0, padding: 0 }}>Free shipping, 30-day return or refund guarantee.</p>
          </div>
          <div className="header__top__right">
            {isAuthenticated ? (
              <>
                <Link to="/profile" style={{ fontSize: '12px', padding: '0 4px' }}>
                  <i className="fa fa-user"></i> {user?.username}
                </Link>
                <button onClick={handleLogout} className="logout-btn" style={{ fontSize: '12px', padding: '0 4px' }}>
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link to="/login" style={{ fontSize: '12px', padding: '0 4px' }}>
                  <i className="fa fa-user"></i> Login
                </Link>
                <Link to="/register" style={{ fontSize: '12px', padding: '0 4px' }}>Register</Link>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Main Header (slim) */}
      <div className="header__main">
        <div className="container">
          <div className="header__logo">
            <Link to="/">
              <h2 style={{ fontSize: '16px', margin: 0, padding: 0 }}>TechZone</h2>
            </Link>
          </div>
          <div className="header__search">
            <form onSubmit={handleSearch}>
              <input
                type="text"
                placeholder="What do you need?"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{ fontSize: '12px', padding: '4px 8px', minWidth: '80px', maxWidth: '120px' }}
              />
              <button type="submit" style={{ fontSize: '12px', padding: '0 8px' }}>
                <i className="fa fa-search"></i>
              </button>
            </form>
          </div>
          <div className="header__cart">
            <Link to="/cart" style={{ fontSize: '14px', padding: '0 4px' }}>
              <i className="fa fa-shopping-bag"></i>
              {cartItemsCount > 0 && <span className="cart-count" style={{ fontSize: '10px', padding: '0 2px' }}>{cartItemsCount}</span>}
            </Link>
            <div className="header__cart__price" style={{ fontSize: '12px', padding: '0 4px' }}>
              <span>₹{cart?.total || '0.00'}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation (slim) */}
      <nav className="header__nav">
        <div className="container">
          <div className="header__menu">
            <button 
              className="mobile-menu-toggle"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <i className="fa fa-bars"></i>
            </button>
            <ul className={mobileMenuOpen ? 'active' : ''}>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/shop">Shop</Link></li>
              <li><Link to="/shop?category=electronics">Electronics</Link></li>
              <li><Link to="/shop?category=fashion">Fashion</Link></li>
              <li><Link to="/shop?category=home">Home & Garden</Link></li>
              <li><Link to="/shop?category=sports">Sports</Link></li>
              {isAuthenticated && (
                <>
                  <li><Link to="/orders">My Orders</Link></li>
                  <li><Link to="/wishlist">Wishlist</Link></li>
                </>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
